// extracted by mini-css-extract-plugin
module.exports = {"container":"HighDemand_container__VD2Us","title":"HighDemand_title__eUGyO","description":"HighDemand_description__BaiKM"};